<template>
  <div id="not-found">
    <template>
      <dd-dc-header/>
      <main class="padding">
        ページが見つかりません。
      </main>
    </template>
  </div>
</template>
<script>
import Header from '../components/common/Header'
import DcHeader from '../hakotan/components/common/DcHeader'
import KgHeader from '../kagull/components/common/NotFoundHeader'
import {PTN_DC, PTN_KG} from '../constants/App'

export default {
  name: 'NotFound',
  components: {
    'dd-header': Header,
    'dd-dc-header': DcHeader,
    'dd-kg-header': KgHeader
  },
  data () {
    return {
      isFit: true,
      isDC: false,
      isKG: false
    }
  },
  methods: {
  },
  created () {
    let url = location.href
    if (PTN_KG.test(url)) {
      this.isFit = false
      this.isKG = true
    } else if (PTN_DC.test(url)) {
      this.isFit = false
      this.isDC = true
    } else {
      this.isFit = true
    }
  }
}
</script>

<style lang="scss" scoped>
#not-found {
  height: calc(100% - 140px);
}
main {
  height: 100%;
  padding: 20px;
  text-align: center;
  background-color: white;
  color: #ff4500;
  font-weight: bold;
}
.padding {
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/main/js/pages/NotFound.vue